export interface IAccessibleCompanyDto {
    code: string | null
    name: string
}

export interface IAccessibleCompany {
    code: string | null
    name: string
}

/**
 * A company the current person has access to with this app, as listed on the "No access" page.
 */
export default class AccessibleCompany implements IAccessibleCompany {
    code: string | null
    name: string

    constructor({
        code,
        name,
    }: IAccessibleCompany) {
        this.code = code
        this.name = name
    }

    /**
     * Creates the model from the API response item.
     * @param dto the response item
     * @returns the accessible company
     */
    static fromDTO(dto: IAccessibleCompanyDto): AccessibleCompany {
        return new AccessibleCompany({
            code: dto.code ?? null,
            name: dto.name,
        })
    }
}
